import Styled from 'styled-components';

const Div = Styled.div`
    min-height: 100vh;
    @media print {
        .ant-layout-header,
        .ant-layout-sider,
        .admin-footer {
            display: none !important;
        }

        .ant-layout,
        .ant-layout-content {
            background: #ffffff !important;
            min-height: auto !important;
        }

        .ant-layout-content {
            margin: 0 !important;
            padding: 0 !important;
        }
    }
    .ant-layout-header {
        width:100%;
        // background:${({ theme }) => theme['primary-color']};
        background: ${({ darkMode, theme }) => (darkMode ? '#fff' : theme['primary-color'])};
        width: 100%;
        color: ${({ darkMode, theme }) => (darkMode ? '#1e1616ff' : '#fff')} ;
        padding: 0 15px;
        align-items: center;
        .logo {
            display: flex;
            align-items: center;
        }
        
    }

    .ant-layout-sider {
        background: ${({ darkMode, theme }) => (darkMode ? '#1e1616ff' :  theme['primary-color'])};
        border-right: 1px solid ${({ darkMode, theme }) => (darkMode ? '#1e1616ff' :  '#1160A9')} ;
        .ant-menu {
            background: transparent;
            border: none;
        }
    }

    .atbd-main-layout {
        background: #f5f6fa;
        .ant-layout-content {
            padding: 24px;
            min-height: calc(100vh - 64px - 64px); /* Header + Footer */
            background: #fff;
        }
    }

    .admin-footer {
        background: #1160A9;
        color: #fff;
    }
    .admin-footer a {
        color: #fff;
        text-decoration: underline;
    }
    .admin-footer a:hover,
    .admin-footer a:focus {
        color: #e6f0ff;       
        text-decoration: none;
    }
`;

const HorizontalMenuWrapper = Styled.div`
    

    width:100%;
    display: flex;
    align-items: center;
    button {
        color:${({ darkMode, theme }) => (darkMode ? '#1e1616ff' :  '#FFF')};
    }
    .ant-menu{
        width:100%;
        background: transparent;
        border: 0;
         display: flex;
        align-items: center;
        .ant-menu-submenu {
            svg{
                color:${({ darkMode, theme }) => (darkMode ? '#1e1616ff' :  '#FFF')};
                font-weight: 500;
            }
        }
        .ant-menu-item {
            display: flex;
            align-items: center;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            padding: 7px 20px;
            margin: 0 5px 0 0;
            border-radius: 8px;
            color: ${({ darkMode, theme }) => (darkMode ? '#1e1616ff' :  '#FFF')};
            transition: all 0.3s ease;
            border: none;
            
            .ant-menu-title-content {
                
            }
            &:after {
                border: none;
            }
            &:focus-visible {
                outline: 0;
            }

            &:hover {
                background-color: ${({ darkMode, theme }) => (darkMode ? theme['primary-color'] :  ' #F58826')};
                color: #fff !important;
                border:none;
                &:after {
                    border: none;
                }
            }

            &.ant-menu-item-selected {
                background-color:${({ darkMode, theme }) => (darkMode ? theme['primary-color'] :  ' #F58826')};
                color: #fff !important;
                border:none;
                &:after {
                    border: none;
                }
            }
        }
    }
`;

const SmallScreenAuthInfo = Styled.div`
        top: 0;
        ${({ theme }) => (!theme.rtl ? 'left' : 'right')}: 0;
        transition: .3s;
        opacity: ${({ hide }) => (hide ? 0 : 1)};
        z-index: ${({ hide }) => (hide ? -1 : 1)};
        box-shadow: 0 2px 30px #9299b810;

`;

const SmallScreenSearch = Styled.div`
        ${({ darkMode }) => (darkMode ? `background: #272B41` : 'background: #fff')};
        width: 100%;
        position: fixed;
        margin-top: ${({ hide }) => (hide ? '0px' : '64px')};
        top: 0;
        ${({ theme }) => (!theme.rtl ? 'left' : 'right')}: 0;
        transition: .3s;
        opacity: ${({ hide }) => (hide ? 0 : 1)};
        z-index: ${({ hide }) => (hide ? -1 : 999)};
        box-shadow: 0 2px 30px #9299b810;

`;

const ModeSwitch = Styled.div`
    background: #ddd;
    width: 200px;
    position: fixed;
    ${({ theme }) => (theme.rtl ? 'left' : 'right')}: 0;
    top: 50%;
    margin-top: -100px;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    padding: 15px;
    border-radius: 5px;
    button{
        margin-top: 5px;
    }
`;



const TopMenuStyle = Styled.div`

    .admin-top-menu{
        ul{
            li{
                font-size:13px;
                display: inline-block;
                position: relative;
                ${({ theme }) => (theme.rtl ? 'padding-left' : 'padding-right')}: 14px;
                @media only screen and (max-width: 1024px){
                    ${({ theme }) => (theme.rtl ? 'padding-left' : 'padding-right')}: 10px;
                }
                &:not(:last-child){
                    ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 14px;
                    @media only screen and (max-width: 1300px){
                        ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 20px;
                    }
                    @media only screen and (max-width: 1199px){
                        ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 14px;
                    }
                    @media only screen and (max-width: 1024px){
                        ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 16px;
                    }
                }
                &.has-subMenu{
                    >a{
                        position: relative;
                        &:before{
                            position: absolute;
                            ${({ theme }) => (theme.rtl ? 'left' : 'right')}: -14px;
                            top: 50%;
                            transform: translateY(-50%);
                            font-family: "FontAwesome";
                            content: '\f107';
                            line-height: 1;
                            color: ${({ theme }) => theme['light-color']};
                        }
                        &.active{
                            &:before{
                                ${({ theme }) => (theme.darkMode ? `color: #000;` : 'color: #393186')};
                            }
                        }
                    }
                }
                &.has-subMenu-left{
                    >a{
                        position: relative;
                        &:before{
                            position: absolute;
                            ${({ theme }) => (theme.rtl ? 'left' : 'right')}: 30px;
                            top: 50%;
                            transform: translateY(-50%);
                            font-family: "FontAwesome";
                            content: '\f105';
                            line-height: 1;
                            color: ${({ theme }) => theme['light-color']};
                        }
                    }
                }
                &:hover{
                    >.subMenu{
                        top: 64px;
                        opacity: 1;
                        visibility: visible;
                    }
                }
                a{
                    display: flex;
                    align-items: center;
                    font-weight: 500;
                    ${({ theme }) => (theme.darkMode ? `color: #ffffff60;` : 'color: #5A5F7D')};
                    &.active{
                        ${({ theme }) => (theme.darkMode ? `color: #fff;` : 'color: #393186')};
                        font-weight:600;
                    }
                    svg,
                    img,
                    i{
                        margin-right: 6px;
                        width: 16px;
                    }
                }
                >ul{
                    li{
                        display: block;
                        position: relative;
                        ${({ theme }) => (theme.rtl ? 'padding-left' : 'padding-right')}: 0;
                        ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 0 !important;
                        a{
                            font-weight: 400;
                            padding: 0 14px;
                            line-height: 2.5;
                            color: #868EAE;
                            transition: .3s;
                            &:hover,
                            &.active{
                                color: ${({ theme }) => theme['primary-color']};
                                background-color: ${({ theme }) => theme['primary-color']}06;
                                ${({ theme }) => (theme.rtl ? 'padding-right' : 'padding-left')}: 16px;
                            }
                        }
                        &:hover{
                            .subMenu{
                                top: 0;
                                ${({ theme }) => (theme.rtl ? 'right' : 'left')}: 240px;
                                @media only screen and (max-width: 1300px){
                                    ${({ theme }) => (theme.rtl ? 'right' : 'left')}: 180px;
                                }
                            }
                        }
                    }
                }
            }
        }
        .subMenu{
            width: 240px;
            background: #fff;
            border-radius: 6px;
            position: absolute;
            ${({ theme }) => (theme.rtl ? 'right' : 'left')}: 0;
            top: 80px;
            padding: 12px 0;
            visibility: hidden;
            opacity: 0;
            transition: 0.3s;
            z-index: 98;
            box-shadow: 0px 15px 40px 0px rgba(82, 63, 105, 0.15);
            @media only screen and (max-width: 1300px){
                width: 180px;
            }
            .subMenu{
                width: 240px;
                background: #fff;
                position: absolute;
                ${({ theme }) => (theme.rtl ? 'right' : 'left')}: 240px;
                top: 0px;
                padding: 12px 0;
                visibility: hidden;
                opacity: 0;
                transition: 0.3s;
                z-index: 98;
                box-shadow: 0px 15px 40px 0px rgba(82, 63, 105, 0.15);
                @media only screen and (max-width: 1300px){
                    width: 200px;
                    ${({ theme }) => (theme.rtl ? 'right' : 'left')}: 180px;
                }
            }
        }
    }
    // Mega Menu
    .admin-top-menu{
        >ul{
            >li{
                &:hover{
                    .megaMenu-wrapper{
                        opacity: 1;
                        visibility: visible;
                        z-index: 99;
                    }
                }
                &.mega-item{
                    position: static;
                }
                .sDash_menu-item-icon{
                    line-height: .6;
                }
                .megaMenu-wrapper{
                    display: flex;
                    position: absolute;
                    text-align: ${({ theme }) => (theme.rtl ? 'right' : 'left')}
                    ${({ theme }) => (theme.rtl ? 'right' : 'left')}: 0;
                    top: 100%;
                    overflow: hidden;
                    z-index: -1;
                    padding: 16px 0;
                    box-shadow: 0px 15px 40px 0px rgba(82, 63, 105, 0.15);
                    border-radius: 0 0 6px 6px;
                    opacity: 0;
                    visibility: hidden;
                    transition: .4s;
                    background-color: #fff;
                    &.megaMenu-small{
                        width: 590px;
                        >li{
                            flex: 0 0 33.3333%;
                        }
                        ul{
                            li{
                                >a{
                                    padding: 0 45px;
                                    position: relative
                                    &:after{
                                        width: 5px;
                                        height: 5px;
                                        border-radius: 50%;
                                        position: absolute;
                                        ${({ theme }) => (theme.rtl ? 'right' : 'left')}: 30px;
                                        top: 50%;
                                        transform: translateY(-50%);
                                        background-color: #C6D0DC;
                                        content: '';
                                        transition: .3s;
                                    }
                                    &:hover,
                                    &.active{
                                        ${({ theme }) => (theme.rtl ? 'padding-right' : 'padding-left')}: 45px;
                                        color: ${({ theme }) => theme['primary-color']};
                                        &:after{
                                            background-color: ${({ theme }) => theme['primary-color']};;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    &.megaMenu-wide{
                        width: 1000px;
                        padding: 5px 0 18px;
                        @media only screen and (max-width: 1300px){
                            width: 800px;
                        }
                        >li{
                            position: relative;
                            flex: 0 0 25%;
                            .mega-title{
                                position: relative;
                                font-size: 14px;
                                font-weight: 500;
                                padding-left: 45px;
                                ${({ theme }) => (theme.rtl ? 'padding-right' : 'padding-left')}: 45px;
                                color: ${({ theme }) => theme['dark-color']};
                                &:after{
                                    position: absolute;
                                    height: 5px;
                                    width: 5px;
                                    border-radius: 50%;
                                    ${({ theme }) => (theme.rtl ? 'right' : 'left')}: 30px;
                                    top: 50%;
                                    transform: translateY(-50%);
                                    background-color: #C6D0DC;
                                    content: '';
                                }
                            }
                        }
                    }
                    ul{
                        li{
                            position: relative;
                            &:hover{
                                >a{
                                    padding-left: 45px;
                                }
                                &:after{
                                    opacity: 1;
                                    visibility: visible;
                                }
                            }
                            >a{
                                line-height: 3;
                                color: #868EAE;
                                font-weight: 400;
                                transition: .3s;
                            }
                            
                            &:after{
                                width: 6px;
                                height: 1px;
                                border-radius: 50%;
                                position: absolute;
                                ${({ theme }) => (theme.rtl ? 'right' : 'left')}: 30px;
                                top: 50%;
                                transform: translateY(-50%);
                                background-color: ${({ theme }) => theme['light-color']};
                                content: '';
                                transition: .3s;
                                opacity: 0;
                                visibility: hidden;
                            }
                        }
                    }
                }
            }
        }
    }
`;

const NavTitle = Styled.p`
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
    color: rgb(146, 153, 184);
    padding: 0px 15px;
    display: flex;
`;

const InstallPopupDiv = Styled.div`
.install-popup {
    display: none;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #333;
    color: #fff;
    transform: translateY(100%);
    transition: transform 0.3s ease-in-out;
  }
  
  .install-popup.show {
    transform: translateY(0);
  }
  
  .popup-content {
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  button {
    padding: 5px 10px;
    background-color: #007bff;
    color: #fff;
    border: none;
    cursor: pointer;
  }
  
  button:hover {
    background-color: #0056b3;
  }
  `;

const ErrorWrapper = Styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  text-align: center;
  img{
    margin-bottom: 100px;
    max-width: 400px;
    width: 100%;
    @media only screen and (max-width: 575px){
      margin-bottom: 30px;
    }
  }
  .error-text{
    font-size: 60px;
    font-weight: 600;
    margin-bottom: 35px;
    color: ${({ theme }) => theme['extra-light-color']};
  }
  p{
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 26px;
  }
  button{
    height: 44px;
  }
`;


const VerticalMenuStyle = Styled.div`
    .ant-menu-inline{
        border:0px;
        .ant-menu-item{
            &:after{
                border:3px solid ${({ theme }) => theme['primaryColor']};
            }
        }
        font-weight:500;
    }

    .ant-menu:not(.ant-menu-horizontal) {
        .ant-menu-item-selected {
            border-radius: 4px; // Rounded corners
            background:${({ theme }) => theme['lightGrayColor']}
        }

    }


    
  }
       
`;


const SidebarWrapper = Styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const MenuItem = Styled.div`


    display: flex;
    // border-radius: 16px;
    flex-direction: column; 
    align-items: center;
    justify-content: center;
    cursor: pointer;
    // transition: 0.3s;
    background-color: transparent;
    margin:5px 0;
    padding: 5px 10px;
    
    

    &.active {
        // 
        background: #f5f5f5;
        span {
            color: ${({ theme }) => theme['primary-color']};
        }
    }
    
    &:hover {
        // padding: 7px 12px;
        background: #f5f5f5;
        span {
            color: ${({ theme }) => theme['primary-color']};
        }
        
    }

    img {
        width: 80%;
        height: 80%;
        object-fit: contain;
        margin-bottom: 3px;
    }

    span {
        font-size: 14px;
        font-weight: 700;
        color: #FFF;
        text-align: center;
        line-height: 1.3;
    }
`;

export { Div, HorizontalMenuWrapper, SmallScreenAuthInfo, SmallScreenSearch, ModeSwitch, TopMenuStyle, VerticalMenuStyle,  NavTitle, InstallPopupDiv, ErrorWrapper, SidebarWrapper, MenuItem };
